import { TableCell } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Input, InputLabel, StyledTableRow } from "components/DSC";
import PropTypes from "prop-types";
import React from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { days } from "./constants";
import { useRowStyles } from "./styles";
import { formulas, getAverage, isDayToggleOff, getDisplayName, getTargetCapacity } from "./utils";
import Checkbox from '@material-ui/core/Checkbox';
import moment from "moment";

const ActivityRow = (props) => {
  const { activity, register, setValue, onUpdate, averageBy, control, target,
     productHours, primaryBuildActivities, dscActivityEnable, selections } = props;
  const classes = useRowStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const daysData = useWatch({ control, name: "daysData", defaultValue: null });
  const averages = useWatch({ control, name: "averages", defaultValue: {} });
  const average = getAverage(activity, averageBy, primaryBuildActivities);
  const targetCapacity = getTargetCapacity(activity, target);

  // switch (activity.name) {
  //   case "Box Destruction ":
  //     activity.name = t("other.actBoxDestruction");
  //     break;
  //   case "Box Image Request":
  //     activity.name = t("other.actBoxImageRequest");
  //     break;
  //   case "Box Internal Project":
  //     activity.name = t("other.actBoxInternalProject");
  //     break;
  //   case "Box Perm Withdrawal":
  //     activity.name = t("other.actBoxPermWithdrawal");
  //     break;
  //   case "Box Retrieval ":
  //     activity.name = t("other.actBoxRetrieval");
  //     break;
  //   case "Box XOD Request":
  //     activity.name = t("other.actBoxRequest");
  //     break;
  //   case "File Destruction":
  //     activity.name = t("other.actFileDestruction");
  //     break;
  //   case "File Image Request":
  //     activity.name = t("other.actFileImageRequest");
  //     break;
  //   case "File Internal Project":
  //     activity.name = t("other.actFileInternalProject");
  //     break;
  //   case "File Perm Withdrawal":
  //     activity.name = t("other.actFilePermWithdrawal");
  //     break;
  //   case "File Retrieval ":
  //     activity.name = t("other.actFileRetrieval");
  //     break;
  //   case "File XOD Request":
  //     activity.name = t("other.actFileRequest");
  //     break;

  //   case "Interfiles":
  //     activity.name = t("other.actInterfiles");
  //     break;
  //   case "PALM In":
  //     activity.name = t("other.actPalmIn");
  //     break;
  //   case "PALM Out":
  //     activity.name = t("other.actPalmOut");
  //     break;
  //   case "Put Away – Box":
  //     activity.name = t("other.actPutAwayBox");
  //     break;
  //   case "Put Away – File":
  //     activity.name = t("other.actPutAwayFile");
  //     break;
  //   case "Rebox Actual":
  //     activity.name = t("other.actReboxActual");
  //     break;
  //   case "Rebox Candidate":
  //     activity.name = t("other.actReboxCandidate");
  //     break;
  //   case "Received New Zone":
  //     activity.name = t("other.actReceivedNewZone");
  //     break;
  //   case "Received Recycled Zone":
  //     activity.name = t("other.actReceivedRecycledZone");
  //     break;
  //   case "Refile Files":
  //     activity.name = t("other.actRefileFiles");
  //     break;
  //   case "Document Insert":
  //     activity.name = t("other.actDocumentInsert");
  //     break;
  //   case "Box Delivery Prep":
  //     activity.name = t("other.actBoxDeliveryPrep");
  //     break;
  //   case "File Delivery Prep":
  //     activity.name = t("other.actFileDeliveryPrep");
  //     break;
  //   case "UNREG. FILE/DOC Search":
  //     activity.name = t("other.actUnreg");
  //     break;
  // }

  return (
    <React.Fragment>
      <StyledTableRow className={classes.root}>
        <TableCell
          className={classes.thRow}
          component="th"
          scope="row"
          style={{ fontWeight: "bold", fontSize: "12px" }}
        >
          <Checkbox
        checked={false}
        disabled
        inputProps={{ 'aria-label': 'primary checkbox' }}
        className={classes.checkbox}
        style={{visibility:'hidden'}}
      />
          {getDisplayName(activity,t)}
        </TableCell>
        {/* <TableCell
          align="right"
          style={{ paddingLeft: "0px", paddingRight: "4px" }}
        >
          <InputLabel
            readOnly
            fullWidth
            value={activity.capacity}
            margin="dense"
            className={classes.capacity}
            inputProps={{
              style: { backgroundColor: "#c8c6c8" },
            }}
          />
        </TableCell> */}
        <TableCell
          align="right"
          style={{ paddingLeft: "0px", paddingRight: "4px" }}
        >
          <InputLabel
            readOnly
            fullWidth
            value={targetCapacity}
            margin="dense"
            className={classes.capacity}
            inputProps={{
              style: { backgroundColor: "#c8c6c8" },
            }}
          />
        </TableCell>
        <TableCell style={{ paddingLeft: "4px", paddingRight: "0px" }}>
          <InputLabel
            readOnly
            fullWidth
            margin="dense"
            inputRef={register()}
            value={moment(selections.week).week()>=moment().week()?
             average:averages[activity.id]?averages[activity.id]:0  }
            //value={average}
            name={`averages.${activity.id}`}
            className={classes.average}
            inputProps={{
              style: { backgroundColor: "#c8c6c8" },
            }}
          />
        </TableCell>
        {days.map((cell, i) => (
          <React.Fragment key={cell}>
            <TableCell
              align="right"
              padding="none"
              style={{
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(1),
              }}
            >
              <Input
                type="number"
                disabled={isDayToggleOff(daysData, `day${i + 1}`) || dscActivityEnable}
                name={`activityData.${activity.id}.day${i + 1}.activityCount`}
                inputRef={register()}
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                fullWidth
                margin="dense"
                defaultValue={""}
                className={classes.countField}
                inputProps={{
                  min: 0,
                }}
                onChange={(e) => {
                  e.persist();
                  const value = parseInt(e.target.value ? e.target.value : "0");
                  const hours = formulas.getHours(targetCapacity, value);
                  const staff = formulas.getStaff(targetCapacity, value, productHours);
                  setValue(
                    `activityData.${activity.id}.day${i + 1}.hours`,
                    value ? hours : ""
                  );
                  setValue(
                    `activityData.${activity.id}.day${i + 1}.staff`,
                    value ? staff : ""
                  );
                  onUpdate();
                }}
                // onBlur={() => onUpdate()}
              />
            </TableCell>
            <TableCell align="left" padding="none">
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                disabled={isDayToggleOff(daysData, `day${i + 1}`) || dscActivityEnable}
                inputRef={register()}
                name={`activityData.${activity.id}.day${i + 1}.hours`}
                className={classes.hrsField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
              />
            </TableCell>
            <TableCell
              align="left"
              padding="none"
              style={{ paddingRight: theme.spacing(1) }}
            >
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                disabled={isDayToggleOff(daysData, `day${i + 1}`) || dscActivityEnable}
                inputRef={register()}
                name={`activityData.${activity.id}.day${i + 1}.staff`}
                className={classes.staffField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
              />
            </TableCell>
          </React.Fragment>
        ))}
        <React.Fragment key="total">
            <TableCell
              align="right"
              padding="none"
              style={{
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(1),
              }}
            >
              <Input
                type="number"
                readOnly
                name={`activityData.${activity.id}.weekTotal.activityCount`}
                inputRef={register()}
                fullWidth
                margin="dense"
                className={classes.countField}
                inputProps={{
                  min: 0,
                  style: { backgroundColor: "#c7c6c7" }
                }}
                defaultValue='0'
              />
            </TableCell>
            <TableCell align="left" padding="none">
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                inputRef={register()}
                name={`activityData.${activity.id}.weekTotal.hours`}
                className={classes.hrsField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
                defaultValue='0.0'
              />
            </TableCell>
            <TableCell
              align="left"
              padding="none"
              style={{ paddingRight: theme.spacing(1) }}
            >
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                inputRef={register()}
                name={`activityData.${activity.id}.weekTotal.staff`}
                className={classes.staffField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
                defaultValue='0.0'
              />
            </TableCell>
          </React.Fragment>
        {/* <TableCell /> */}
      </StyledTableRow>
    </React.Fragment>
  );
};
ActivityRow.propTypes = {
  activity: PropTypes.any,
  register: PropTypes.any,
  control: PropTypes.any,
  setValue: PropTypes.any,
  activityId: PropTypes.any,
  onUpdate: PropTypes.func,
  averageBy: PropTypes.any,
};
export default ActivityRow;
